<template lang="html">
  <svg class="main-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 242 72">
    <g fill="none">
      <g transform="translate(-153 -29)translate(153 30)">
        <text class="text">
          <tspan x="125" y="22">
            Promotional
          </tspan>
          <tspan x="125" y="42">
            Management
          </tspan>
          <tspan x="125" y="62">
            Group
          </tspan>
        </text>
        <path d="M109 0L109 70" stroke="#FFF"/>
        <g class="logo">
          <path d="M92.9 30.6L71.1 49.4C11.7 47 0 64.2 0 64.2 0 64.2 17.2 41.8 35.5 37 51.4 32.9 92.9 30.6 92.9 30.6ZM60.9 58.4C60.9 58.4 17.8 53.2 0.7 64.7 0.7 64.7 9.6 55 33 53.7 56.5 52.4 66 54 66 54L60.9 58.4Z"/>
          <path d="M27 14.9C26.4 17.3 24.1 17.7 22 17.7L20 17.7 21.3 12.4 23.2 12.4C25.4 12.4 27.5 12.6 27 14.9M83.9 12.3C86.4 12.3 88.6 12.9 89.7 13.6L91.1 7.8C89 7.3 87 7 82.6 7 76.9 7 71.3 9.1 68.2 13.3L69.6 7.4 56.4 7.4 50.6 19.1 50.5 19.1 50.3 7.4 37 7.4 36.1 11.4C35.3 8.3 32 7.4 29.2 7.4L13.8 7.4 8.6 28.8 17.6 28.8 19.1 22.6 25.5 22.6C29 22.6 32.4 21.3 34.4 18.4L31.9 28.8 39.5 28.8 43.6 12 43.8 12 44.2 28.8 51.6 28.8 60.3 12 60.3 12 56.4 28.8 64.4 28.8 65.9 22.7C66.9 27 71.4 29.2 77.3 29.2 81 29.2 83.9 28.8 87.2 28L89.6 17.9 82 17.9 80.6 23.6C80 23.8 79.3 23.8 78.6 23.8 75.1 23.8 74.4 21.2 75.1 18.3 76 14.4 79.4 12.3 83.9 12.3"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'main-logo',
    data () {
      return {

      }
    }
  }
</script>

<style lang="scss">
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .main-logo {
    width: 175px;
    height: auto;
    @include breakpoint(max-width $xs) {
      width: 100px;
      height: auto;
    }
    @include breakpoint($md) {
      width: 242px;
    }
  }

  .logo, .text {
    fill: $white;
  }

  .text {
    font-family: 'Barlow Condensed';
    font-size: 16px;
    font-weight: normal;
    line-spacing: 20;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue